(function () {
  const curSelection = $("#currentSelection");

  function deselectAddOns() {
    $(".addon_by_variants-container .addon input").each(function () {
      $(this).prop("checked", false).trigger("change");
    });
  }

  function updateAddOnDisplay() {
    $(".addon_by_variants-container .addon").each(function () {
      const variantIds_string = $(this).data("main-product-variant-ids");
      if (variantIds_string) {
        const variantIds = variantIds_string.toString().split(",");
        if (
          variantIds.includes($(curSelection).attr("data-variant").toString())
        ) {
          $(this).removeClass("hide");
        } else {
          $(this).addClass("hide");
        }
      } else {
        $(this).addClass("hide");
      }
    });
    deselectAddOns();
  }
  updateAddOnDisplay();

  $(".addon_by_variants-container").each(function () {
    const addons = $(this).find(".addons");
    const productId = addons.data("product-id");
    const selectedVariantId = $(this).find(".selected_variantId");

    const options = addons.find(`input[name="addon-${productId}"]`);
    options.on("change", function () {
      if (this.checked) {
        selectedVariantId.text($(this).val());
      } else {
        selectedVariantId.text("");
      }
      options.not(this).prop("checked", false);
    });
  });

  function watchCurSelection() {
    let target = curSelection[0];

    let observer = new MutationObserver(function (mutations) {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName.startsWith("data-")
        ) {
          const changedAttr = mutation.attributeName;
          const newValue = target.getAttribute(changedAttr);
          // console.log(`Attribute ${changedAttr} changed to: ${newValue}`);
          updateAddOnDisplay();
        }
      });
    });

    observer.observe(target, {
      attributes: true,
    });
  }
  watchCurSelection();

  function updateLinks() {
  console.log("warranty script");

  const currentSelection = $("#currentSelection").attr("data-variant");
  const bundleAddOn = $(".selectedgroupsell").text();
  const doorCloserAddOn = $(".selectedgroupsell-second").text();

  // ---- collect raw addon strings (variantId OR variantId-qty)
  const warrantyAddOnItems = [];

  $(".selected_variantId").each(function () {
    const raw = $(this).text().trim();
    if (!raw) return;

    raw.split(",").forEach(function (item) {
      warrantyAddOnItems.push(item.trim());
    });
  });

  const atcButton = $("#AddToCart-button");
  const checkoutButton = $("#initateCheckout");

  let atcLink = `/cart/add?id[]=${currentSelection}`;
  let checkoutLink = `/cart/${currentSelection}:1`;

  // ---- bundle
  if (bundleAddOn) {
    atcLink += `&id[]=${bundleAddOn}`;
    checkoutLink += `,${bundleAddOn}:1`;
  }

  // ---- door closer
  if (doorCloserAddOn) {
    atcLink += `&id[]=${doorCloserAddOn}`;
    checkoutLink += `,${doorCloserAddOn}:1`;
  }

  // ---- addons (cart link keeps -qty)
  warrantyAddOnItems.forEach(function (item) {
    atcLink += `&id[]=${item}`;
  });

  // ---- addons (checkout link converts to :qty)
  warrantyAddOnItems.forEach(function (item) {
    const parts = item.split("-");
    const variantId = parts[0];
    const qty = parts.length > 1 ? Number(parts[1]) || 1 : 1;

    checkoutLink += `,${variantId}:${qty}`;
  });

  

  atcButton.attr("href", atcLink);
  checkoutButton.attr("href", checkoutLink);
}


  let variantObserverInitialized = false;

function watchSelectedVariantId() {
  if (variantObserverInitialized) return;
  variantObserverInitialized = true;

  $(".selected_variantId").each(function () {
    const target = this;

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === "characterData" ||
          mutation.type === "childList"
        ) {
          updateLinks();
        }
      });
    });

    observer.observe(target, {
      characterData: true,
      childList: true,
      subtree: true,
    });
  });
}

  $(".addon-container").click(function () {
    watchSelectedVariantId();
    updateLinks();
  });
  watchSelectedVariantId();
})();
